import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { ExclamationTriangleIcon } from '@heroicons/react/24/outline';
import { Callout } from './exercise.js';
export const UnknownDirective = ({ node }) => {
    const titleNode = (_jsxs(_Fragment, { children: [_jsx("code", { children: node.name }), " - Unknown Directive"] }));
    return (_jsx(Callout, { title: titleNode, color: 'red', dropdown: true, Icon: ExclamationTriangleIcon, children: _jsx("pre", { children: node.value }) }));
};
const UNKNOWN_MYST_RENDERERS = {
    mystDirective: UnknownDirective,
};
export default UNKNOWN_MYST_RENDERERS;
